module.exports = __webpack_public_path__ + "static/img/4559_phase_function_Paper_PointsHejduk_Prediction.6e64eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4559_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dVBU
// module chunks = 0